var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["button-checkbox", _vm.modify] }, [
    _c("input", {
      staticClass: "button-checkbox__input",
      attrs: {
        type: "checkbox",
        id: _vm.name,
        name: _vm.name,
        disabled: _vm.disabled
      },
      domProps: { checked: _vm.checked }
    }),
    _vm._v(" "),
    _c(
      "label",
      { staticClass: "button-checkbox__label", attrs: { for: _vm.name } },
      [
        _c("span", { staticClass: "button-checkbox__text" }, [
          _vm._v(_vm._s(_vm.value))
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }